module.exports = __webpack_public_path__ + "assets/img/654000.53943137.png";